export default "__VITE_ASSET__DUgs7k1T__"